import {  createApp } from "vue";
import App from "./App.vue";
import { createVfm } from "vue-final-modal";
import permissionDirective from "./directives/permission";
import router from "./router/routes";
import store from "./vuex/store";
import common_function from "@/assets/commonjs/common_function";
//import initHeatmapTracker from "@/utils/heatmapTracker";

// initHeatmapTracker(router);
// const isSSR = typeof window === "undefined";

export default function () {
  router.afterEach(() => {
    console.log("afterEach invoked");
    setTimeout(() => {
      common_function();
    }, 300);
  });

  // Add navigation guard to check token expiration
  router.beforeEach(async (to, from) => {
    // ✅ ADD THIS LINE
    if (to.name === "UserProfile") return true;
    
    // ✅ FIX: Update public routes - use path prefix matching
    const publicRoutes = [
      "/blogs",
      "/blog/",
      "/showJobsPage",
      "/savedTemplate",
      "/registration-successful",
      "/PrivacyPolicy",
      "/Terms",
      "/AboutUs",
      "/contactUs",
      "/refundpolicy",
      "/forgotresetpassword"
    ];

    const isHomeRoute = to.path === "/";
    
    // ✅ Check if it's a renew-subscription route (with any userId)
    const isRenewSubscriptionRoute = to.path.startsWith("/renew-subscription/");
    
    // ✅ Check if it's a user profile route (allow public access)
    const isUserProfileRoute = to.path.match(/^\/user\/[^/]+$/);
    
    const isPublicRoute =
      isHomeRoute || 
      isRenewSubscriptionRoute ||
      isUserProfileRoute ||
      publicRoutes.some((p) => to.path.startsWith(p));

    // 🔹 If it's a public route, always allow
    if (isPublicRoute) {
      console.log("✅ Public route allowed:", to.path);
      return true;
    }

    // 🔹 If no token yet (user just opened app before login), wait briefly
    const waitForToken = () =>
      new Promise((resolve) => {
        let tries = 0;
        const interval = setInterval(() => {
          const token =
            sessionStorage.getItem("token") || localStorage.getItem("token");
          if (token || tries > 10) {
            clearInterval(interval);
            resolve(token);
          }
          tries++;
        }, 100);
      });

    const token = await waitForToken();

    // 🔹 If no token at all → redirect to home/login
    if (!token) {
      console.log("No token found. Redirecting to home.");
      await store.dispatch("logout");
      return { path: "/" };
    }

    // 🔹 Check token expiry via store
    await store.dispatch("isTokenExpired");
    const isTokenExpired = store.getters.isTokenExpired;

    console.log(`Navigating to ${to.fullPath}`);
    console.log(`Token expired? ${isTokenExpired}`);
    console.log(`Public route? ${isPublicRoute}`);

    // 🔹 If token expired → logout (which redirects to home)
    if (isTokenExpired) {
      console.log("Token expired. Logging out...");
      await store.dispatch("logout");
      return false; // cancel navigation after logout redirect
    }

    // 🔹 Otherwise, continue navigation
    return true;
  });

  const app =  createApp(App);

  app.use(store);
  app.use(router);

  const vfm = createVfm();
  app.use(vfm);

  app.directive("permission", permissionDirective);

  return {
    app,
    store,
    router,
  };
}